import { Typography } from '@/src/packages/components/ui/Typography';
import { Markdown } from '@/src/packages/components/ui/Markdown';

export const ProductDescription = ({
  description,
}: {
  description: string;
}) => {
  return (
    <Typography>
      <Markdown content={description || ''} />
    </Typography>
  );
};
